import { render, staticRenderFns } from "./GlobalLoading.vue?vue&type=template&id=3c8f25a0&scoped=true&"
import script from "./GlobalLoading.vue?vue&type=script&lang=js&"
export * from "./GlobalLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8f25a0",
  null
  
)

export default component.exports